import React from 'react'
import { INITIAL_VALUES_ADD_ADMIN, VALIDATION_SCHEMA_ADD_ADMIN } from './utils';
import HOCButton from 'web/components/Button';
import TextInput from 'web/components/form-elements/TextInput';
import { Form, Formik} from 'formik';

export default function AddNonUserModal(props) {
    return (
        <div>
            <Formik
                initialValues={INITIAL_VALUES_ADD_ADMIN}
                validationSchema={VALIDATION_SCHEMA_ADD_ADMIN}
                onSubmit={(values) => {
                }}>
                {(props) => {
                    const { isValid, dirty} = props;
                    return (
                        <>
                            <Form>
                                <p className="mt-0">First Name</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='firstName'
                                            showErrorMessages={true}
                                        />
                                    </div>
                                </div>
                                <p className="mt-0">Last Name</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='lastName'
                                            showErrorMessages={true}
                                        />
                                    </div>
                                </div>
                                <p className="mt-0">Email ID</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='email'
                                            showErrorMessages={true}
                                        />
                                    </div>
                                </div>
                                <p className="mt-0">Cell Phone Number</p>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: '100%' }}>
                                        <TextInput
                                            name='cellNumber'
                                            showErrorMessages={true}
                                        />
                                    </div>
                                </div>

                                <div style={{ marginTop: '15px', textAlign: '-webkit-center' }}>
                                    <HOCButton
                                        type='app-green-button submitBtn'
                                        handleClick={() => {
                                        }}
                                        disabled={!(isValid && dirty)}>
                                        Add User
                                    </HOCButton>
                                </div>
                            </Form>
                        </>
                    );
                }}
            </Formik>
        </div>
    )
}